import React, { useState } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import { useTranslation } from 'react-i18next'
import EmptyCard from '../../common/EmptyCard'
import CardSubTitle from '../../common/CardSubTitle'
import Avatar from 'srcReact/components/common2/Avatar'
import IconButton from 'srcReact/components/common2/IconButton'
import { useDispatch, useSelector } from 'react-redux'
import { dashboardActions } from 'srcReact/Dashboard/actions'
import Modal from 'srcReact/components/common2/Modal'
import AddGroupInterests from 'srcReact/components/common2/AddGroupInterests'
import UserList from '../../common/UserList'

function PendingApproval({ newMembers, autoApprovalToJoin, showUserLightModal, isFullWidth }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isInterestModalOpen, setIsInterestModalOpen] = useState(false)

  const {
    dashboardDetail: { data: { group_id, group_name, group_info: { interests } = {} } = {} }
  } = useSelector((state) => state)

  const openInterestModal = () => {
    setIsInterestModalOpen(true)
  }
  const closeInterestModal = () => {
    setIsInterestModalOpen(false)
  }

  const refuseAction = (userId) => {
    dispatch(dashboardActions.rejectNewMember(group_id, userId))
  }
  const acceptAction = (userId) => {
    dispatch(dashboardActions.acceptNewMember(group_id, userId))
  }
  return (
    autoApprovalToJoin === 0 &&
    newMembers?.length > 0 && (
      <div className={`${parentStyles.card} ${styles.pendingApprovals} ${isFullWidth && styles.fullWidth}`}>
        <React.Fragment>
          <CardSubTitle title={t('dashboard.pendingApprovalCount', { count: newMembers?.length || 0 })} />
          <UserList
            users={newMembers}
            renderAction={(userInfo) => (
              <React.Fragment>
                <IconButton
                  className={styles.refuseButton}
                  iconName='close24'
                  iconSize='x-small'
                  onClick={() => refuseAction(userInfo.id)}
                />
                <IconButton
                  className={styles.acceptButton}
                  iconName='check24'
                  iconSize='x-small'
                  onClick={() => acceptAction(userInfo.id)}
                />
              </React.Fragment>
            )}
          />
        </React.Fragment>

        {isInterestModalOpen && (
          <Modal
            isOpen={isInterestModalOpen}
            title={t('group.editGroup.groupInterests', { type: t('formlabel.interest', { count: 0 }).toLowerCase() })}
            handleClose={closeInterestModal}>
            <AddGroupInterests
              isModal={true}
              groupId={group_id}
              groupName={group_name}
              interests={interests}
              closeModal={closeInterestModal}
            />
          </Modal>
        )}
      </div>
    )
  )
}

export default PendingApproval
